import { useState } from "react"
import { useNotification } from ".."

const ResponseHandler = () => {

    const [response, setResponse] = useState(null)
    const {notify} = useNotification()

    const handleResponse = ({data, alert, redirect}) => {
    
        // Sets the Initial Response Object From Server
        setResponse(data)

        //Notify on Response
        if (alert) {
            notify({
              status: alert?.status,
              title: alert?.title,
              msg: alert?.message,
            });
        }

        if(redirect){
            window.location.href(redirect?.page)
        }
        
    }
    
    return {
        response,
        handleResponse
    }

}


export default ResponseHandler